import { render, staticRenderFns } from "./PermissionTips.vue?vue&type=template&id=313337b5"
import script from "./PermissionTips.vue?vue&type=script&lang=ts&setup=true"
export * from "./PermissionTips.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports